import script from "./NumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=1179c988&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1179c988"]])

export default __exports__